export { toRequestQuery } from "../../../shared/api/transformers";

export function normalizeListResponse(data) {
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data)) return data;
  return [];
}
